import React, { ReactNode } from 'react';
import { useTabsContext } from './Tabs';
import { StyledTabPanels } from './Tabs.styles';

export interface TabPanelsProps {
  children?: ReactNode;
  className?: string;
}

const TabPanels: React.FC<TabPanelsProps> = ({ children, className }) => {
  const context = useTabsContext();

  if (!context) {
    throw new Error('TabPanels must be used within a Tabs component');
  }

  const { orientation } = context;

  return (
    <StyledTabPanels
      className={className}
      orientation={orientation}
    >
      {children}
    </StyledTabPanels>
  );
};

export default TabPanels;